import _ from 'lodash';
import { GROWTH_CALCULATORS } from 'spw-constants';
import { CalculatorType } from 'spw-redux/modules/calculators/types';
import { PlainProgramScenario } from '../../models/Scenario';

const onlyNumbersRegex = /[^0-9.]+/g;
const allNumbersRegex = /[^0-9.-]+/g;
const onlyOneDecimalAllowedRegex1 = /\./;
const onlyOneDecimalAllowedRegex2 = /\./g;
const onlyOneDecimalAllowedRegex3 = /#/;

export const convertValueToDecimal = (value: string) =>
  value
    .replace(allNumbersRegex, '')
    .replace(/\./, '#')
    .replace(/\./g, '')
    .replace(/#/, '.') // ensure there is only one decimal '.' allowed in the string
    .replace(/(\d*\.\d)\d*/, '$1'); // only allow one digit after decimal

const convertToDecimal = (value: string) =>
  _(value)
    .replace(onlyNumbersRegex, '') // replace anything not a number
    .replace(onlyOneDecimalAllowedRegex1, '#') // these
    .replace(onlyOneDecimalAllowedRegex2, '') // lines
    .replace(onlyOneDecimalAllowedRegex3, '.') // ensure there is only one decimal '.' allowed in the string
    .replace(/^0*(\d.*)$/, '$1'); // removes all left zeros if value is greater than zero

export const convertToSingleDec = (value: string) =>
  convertToDecimal(value).replace(/(\d*\.\d)\d*/, '$1'); // only allow one digit after decimal

export const convertToTwoDec = (value: string) =>
  convertToDecimal(value).replace(/(\d*\.\d\d)\d*/, '$1'); // only allow two digit after decimal

export const removeDecimals = (value: string) =>
  _(value).trimStart('0').replace(onlyNumbersRegex, ''); // replace anything not a number or decimal

export const formatWithDecimals = (value: string, numberOfDecimals = 2) => {
  if (numberOfDecimals === 2) return convertToTwoDec(value);
  if (numberOfDecimals === 1) return convertToSingleDec(value);
  return removeDecimals(value);
};

export const areScenariosEqual = (
  scenarioA: PlainProgramScenario,
  scenarioB: PlainProgramScenario,
  propertiesToOmit: string[]
) => {
  return (
    JSON.stringify(_.omit(scenarioA, propertiesToOmit)) ===
    JSON.stringify(_.omit(scenarioB, propertiesToOmit))
  );
};

export const isUSFCalculator = (calculatorType: string) => {
  return [GROWTH_CALCULATORS.buildingUsf, GROWTH_CALCULATORS.floorUsf].includes(
    calculatorType as CalculatorType
  );
};
